import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EndUserInstanceLocationType } from "../types/EndUserInstanceLocationType";
import { apiClient } from "src/utils/Api/apiClient";

interface endUserInstanceLocationState {
        endUserInstanceLocations: Array<EndUserInstanceLocationType>;
        endUserInstanceLocationsLoading: boolean;
        endUserInstanceLocationsError: string | null;
}

const initialState: endUserInstanceLocationState = {
        endUserInstanceLocations: [],
        endUserInstanceLocationsLoading: false,
        endUserInstanceLocationsError: null
}

export const getEndUserInstanceLocations = createAsyncThunk(
        'endUserInstanceLocation/getEndUserInstanceLocations',
        async (endUserInstanceLocationData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUserInstanceLocation/getEndUserInstanceLocations/${endUserInstanceLocationData}`);
                        return response.data;
                } catch (endUserInstanceLocationError: any) {
                        return rejectWithValue(endUserInstanceLocationError.response.data || 'An error occured');
                }
        }
);

export const getEndUserInstanceLocationsByEndUserInstanceID = createAsyncThunk(
        'endUserInstanceLocation/getEndUserInstanceLocationsByEndUserInstanceID',
        async (endUserInstanceLocationData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUserInstanceLocation/getEndUserInstanceLocationsByEndUserInstanceID/${endUserInstanceLocationData}`);
                        return response.data;
                } catch (endUserInstanceLocationError: any) {
                        return rejectWithValue(endUserInstanceLocationError.response.data || 'An error occured');
                }
        }
);

export const deleteEndUserInstanceLocation = createAsyncThunk(
        'endUserInstanceLocation/deleteEndUserInstanceLocation',
        async (endUserInstanceLocationData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUserInstanceLocation/deleteEndUserInstanceLocation', endUserInstanceLocationData).then();
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);

const endUserInstanceLocationsSlice = createSlice({
        name: 'endUserInstanceLocations',
        initialState,
        reducers: {
                endUserInstanceLocationsReset: () => initialState,
                insertEndUserInstanceLocation: (state, action) => {
                        const id = action.payload.Id;
                        const index = state.endUserInstanceLocations.findIndex(item => item.Id === id);
                        if (index !== -1) {
                                state.endUserInstanceLocations[index] = action.payload;
                        }
                        else {
                                state.endUserInstanceLocations.push(action.payload);
                        }
                },
        },
        extraReducers: (builder) => {
                //get endUserInstanceLocations from server
                builder.addCase(getEndUserInstanceLocations.pending, (state) => {
                        state.endUserInstanceLocationsLoading = true;
                        state.endUserInstanceLocationsError = null;
                });
                builder.addCase(getEndUserInstanceLocations.fulfilled, (state, action) => {
                        state.endUserInstanceLocationsLoading = false;
                        state.endUserInstanceLocations = action.payload;
                });
                builder.addCase(getEndUserInstanceLocations.rejected, (state, action) => {
                        state.endUserInstanceLocationsLoading = false;
                        state.endUserInstanceLocationsError = action.payload as string;
                });

                //get endUserInstanceLocations from server by enduser id
                builder.addCase(getEndUserInstanceLocationsByEndUserInstanceID.pending, (state) => {
                        state.endUserInstanceLocationsLoading = true;
                        state.endUserInstanceLocationsError = null;
                });
                builder.addCase(getEndUserInstanceLocationsByEndUserInstanceID.fulfilled, (state, action) => {
                        state.endUserInstanceLocationsLoading = false;
                        state.endUserInstanceLocations = action.payload;
                });
                builder.addCase(getEndUserInstanceLocationsByEndUserInstanceID.rejected, (state, action) => {
                        state.endUserInstanceLocationsLoading = false;
                        state.endUserInstanceLocationsError = action.payload as string;
                });

        }
});

export const { endUserInstanceLocationsReset, insertEndUserInstanceLocation } = endUserInstanceLocationsSlice.actions;
export default endUserInstanceLocationsSlice.reducer;
